import { instance } from '../../config/axios';

const actions = {
  getXmacnaLoginUrl(_, data) {
    return new Promise((resolve, reject) => {
      instance()
        .post('/auth/xmacna/login', data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  }
};

export default {
  namespaced: true,
  actions
};
